import {
  StdVectorI8,
  StdVectorPoint3F,
  StdVectorU,
  TriMeshRayIntersector3F,
} from '@seddi/wa-garments-geometry';

export type TriMeshBvh = {
  readonly pIntersector: TriMeshRayIntersector3F;
  readonly pIntersectorIndices: StdVectorU;
  readonly pIntersectorVertices: StdVectorPoint3F;
};

export const build = (indices: Uint16Array | Uint32Array, vertices: Float32Array) => {
  return new Promise<TriMeshBvh>(resolve => {
    const worker = new Worker(new URL('./workers/meshBvh.worker.ts', import.meta.url), {
      type: 'module',
    });

    worker.onmessage = (event: MessageEvent<Uint8Array>) => {
      const bytes = event.data;
      worker.terminate();

      const pIntersectorIndices = new StdVectorU();
      pIntersectorIndices.resize(indices.length);
      pIntersectorIndices.data().set(indices as unknown as number[]);
      const pIntersectorVertices = new StdVectorPoint3F();
      pIntersectorVertices.resize(vertices.length / 3);
      pIntersectorVertices.data().set(vertices);
      const pBytes = new StdVectorI8();
      pBytes.resize(bytes.length);
      pBytes.data().set(bytes);
      const pIntersector = new TriMeshRayIntersector3F(pIntersectorIndices, pIntersectorVertices);
      pIntersector.load(pBytes);
      pBytes.delete();

      resolve({ pIntersector, pIntersectorIndices, pIntersectorVertices });
    };

    worker.postMessage({ indices: indices as Uint32Array, vertices });
  });
};

export const dispose = (self: TriMeshBvh) => {
  self.pIntersector.delete();
  self.pIntersectorIndices.delete();
  self.pIntersectorVertices.delete();
};
